import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiUrl } from "../../../constants";

export const getScheduledDeliveries = createAsyncThunk(
  "package/getScheduledDeliveries",
  async (filters = {}, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    // Build query string from filters
    const params = new URLSearchParams();
    if (filters.driver) params.append("driver_id", filters.driver);
    if (filters.repeat) params.append("freq", filters.repeat);
    if (filters.dayOfWeek?.length)
      params.append("weekdays", filters.dayOfWeek.join(","));
    if (filters.customer_name)
      params.append("customer_name", filters.customer_name);

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await fetch(
        `${apiUrl}/get_scheduled_packages?${params.toString()}`,
        requestOptions
      );

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const error = await response.json();
          errorMessage = error.msg || errorMessage;
        } catch (e) {
          errorMessage = await response.text();
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Fetching scheduled deliveries failed:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const scheduledDeliveriesSlice = createSlice({
  name: "scheduledDeliveries",
  initialState: {
    deliveries: [],
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
  },
  reducers: {
    clearScheduledDeliveriesState: (state) => {
      state.deliveries = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getScheduledDeliveries.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getScheduledDeliveries.fulfilled, (state, action) => {
        state.status = "success";
        state.deliveries = action.payload.scheduled_packages;
      })
      .addCase(getScheduledDeliveries.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
        state.deliveries = [];
      });
  },
});

export const { clearScheduledDeliveriesState } =
  scheduledDeliveriesSlice.actions;
export default scheduledDeliveriesSlice.reducer;
